module.exports = __webpack_public_path__ + "static/13-9404302405a1c531b53adf3a11283c77.jpg";